const BODY = document.querySelector("body");
const HAMBURGER = document.querySelector(".header__icon--hamburger");
HAMBURGER.addEventListener("click", function () {
  BODY.classList.toggle("js-drawer-open");
});

new Swiper("#custom-header-drawer-menu", {
  slidesPerView: 3.1, // 一度に表示する枚数
  spaceBetween: "2.31884058%",
  freeMode: true,
});

new Swiper("#custom-header-mega-menu-sub-menu", {
  slidesPerView: 8.5, // 一度に表示する枚数
  spaceBetween: "0.8333333333%",
  freeMode: true,
  centerInsufficientSlides: true,
});
